import { EThemeType } from "redux/reducers";
interface IProp {
  sidebar?: boolean;
   isWsActive?: boolean;
    theme?: EThemeType;
}
export const UseWsIcon = ({ sidebar,isWsActive,theme }: IProp) => {
  if (sidebar) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <g clipPath="url(#clip0_2276_3399)">
          <path
            d="M5.75 2H10.25C10.3875 2 10.5 2.1125 10.5 2.25V3.5H5.5V2.25C5.5 2.1125 5.6125 2 5.75 2ZM4 2.25V3.5H2C0.896875 3.5 0 4.39687 0 5.5V8.5H6H10H16V5.5C16 4.39687 15.1031 3.5 14 3.5H12V2.25C12 1.28438 11.2156 0.5 10.25 0.5H5.75C4.78438 0.5 4 1.28438 4 2.25ZM16 9.5H10V10.5C10 11.0531 9.55313 11.5 9 11.5H7C6.44688 11.5 6 11.0531 6 10.5V9.5H0V13.5C0 14.6031 0.896875 15.5 2 15.5H14C15.1031 15.5 16 14.6031 16 13.5V9.5Z"
            fill={isWsActive && theme=== 'light'? "#4338CA": isWsActive && theme=== 'dark'? "#527AE6":"#94A3B8"}
          />
        </g>
        <defs>
          <clipPath id="clip0_2276_3399">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
      >
        <g clipPath="url(#clip0_1490_2474)">
          <path
            d="M3.59375 0.9375H6.40625C6.49219 0.9375 6.5625 1.00781 6.5625 1.09375V1.875H3.4375V1.09375C3.4375 1.00781 3.50781 0.9375 3.59375 0.9375ZM2.5 1.09375V1.875H1.25C0.560547 1.875 0 2.43555 0 3.125V5H3.75H6.25H10V3.125C10 2.43555 9.43945 1.875 8.75 1.875H7.5V1.09375C7.5 0.490234 7.00977 0 6.40625 0H3.59375C2.99023 0 2.5 0.490234 2.5 1.09375ZM10 5.625H6.25V6.25C6.25 6.5957 5.9707 6.875 5.625 6.875H4.375C4.0293 6.875 3.75 6.5957 3.75 6.25V5.625H0V8.125C0 8.81445 0.560547 9.375 1.25 9.375H8.75C9.43945 9.375 10 8.81445 10 8.125V5.625Z"
            fill="#737373"
          />
        </g>
        <defs>
          <clipPath id="clip0_1490_2474">
            <rect width="10" height="10" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
};
